import { render, staticRenderFns } from "./whiteBookFile_zhCN.vue?vue&type=template&id=e9888860&scoped=true"
import script from "./whiteBookFile_zhCN.vue?vue&type=script&lang=js"
export * from "./whiteBookFile_zhCN.vue?vue&type=script&lang=js"
import style0 from "./whiteBookFile_zhCN.vue?vue&type=style&index=0&id=e9888860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9888860",
  null
  
)

export default component.exports